import { createReducer } from '@reduxjs/toolkit';
import { IDemandOrderDto, IReturnOrderDto } from '../../api/ClientApi';
import { myAssert } from '../../common/console';

import {
    clearOrderForOrderClosing,
    closeDemandOrder,
    closeReturnOrder,
    importDemandOrderForClosing,
    importReturnOrderForClosing,
} from '../actions/orderActions';
import { clearBaseEntityState, IBaseEntityState, SaveEntityStatus } from './common';

export interface CloseOrderFormReducerState extends IBaseEntityState {
    demandOrder: IDemandOrderDto | null;
    returnOrder: IReturnOrderDto | null;
}

function clearState(state: CloseOrderFormReducerState): void {
    state.demandOrder = null;
    state.returnOrder = null;

    clearBaseEntityState(state);
}

function getInitialState(): CloseOrderFormReducerState {
    const state: CloseOrderFormReducerState = {
        demandOrder: null,
        returnOrder: null,
        baseJsonString: null,
        currentJsonString: null,
        isChanged: undefined,
        saveStatus: SaveEntityStatus.None,
        modified: undefined,
    };

    clearState(state);

    return state;
}

export const closeOrderFormReducer = createReducer<CloseOrderFormReducerState>(
    getInitialState(), // Initial state
    (builder) => {
        builder
            .addCase(importDemandOrderForClosing.fulfilled, (state: CloseOrderFormReducerState, action: any) => {
                clearState(state);

                const payload: IDemandOrderDto = action.payload;

                myAssert(() => !!payload, 'Required Data for Import');

                state.demandOrder = payload;
            })
            .addCase(importReturnOrderForClosing.fulfilled, (state: CloseOrderFormReducerState, action: any) => {
                clearState(state);

                const payload: IReturnOrderDto = action.payload;

                myAssert(() => !!payload, 'Required Data for Import');

                state.returnOrder = payload;
            })
            .addCase(clearOrderForOrderClosing, (state: CloseOrderFormReducerState, action: any) => {
                clearState(state);
            })
            .addCase(closeDemandOrder.pending, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(
                    () => state.saveStatus === SaveEntityStatus.None || state.saveStatus === SaveEntityStatus.Error,
                    '',
                    false,
                );

                state.saveStatus = SaveEntityStatus.Pending;
            })
            .addCase(closeDemandOrder.fulfilled, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(() => state.saveStatus === SaveEntityStatus.Pending, '', false);

                state.saveStatus = SaveEntityStatus.Saved;
            })
            .addCase(closeDemandOrder.rejected, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(() => state.saveStatus === SaveEntityStatus.Pending, '', false);

                state.saveStatus = SaveEntityStatus.Error;
            })
            .addCase(closeReturnOrder.pending, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(
                    () => state.saveStatus === SaveEntityStatus.None || state.saveStatus === SaveEntityStatus.Error,
                    '',
                    false,
                );

                state.saveStatus = SaveEntityStatus.Pending;
            })
            .addCase(closeReturnOrder.fulfilled, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(() => state.saveStatus === SaveEntityStatus.Pending, '', false);

                state.saveStatus = SaveEntityStatus.Saved;
            })
            .addCase(closeReturnOrder.rejected, (state: CloseOrderFormReducerState, action: any) => {
                myAssert(() => state.saveStatus === SaveEntityStatus.Pending, '', false);

                state.saveStatus = SaveEntityStatus.Error;
            });
    },
);
